import * as React                 from "react";
import { FC }                     from "react";
import { Checkbox, Form }         from "semantic-ui-react";
import Time                       from "../../../../domain/fundamentals/date/Time";
import ReservationBusinessDayType from "../../../../domain/reservation/ReservationBusinessDayType";
import ReservationBusinessTime    from "../../../../domain/reservation/ReservationBusinessTime";
import TimeRangeSelector          from "../../common/TimeRangeSelector";

interface Props {
  reservationBusinessTime: ReservationBusinessTime;
  onChangeFrom: (value: Time) => void;
  onChangeTo: (value: Time) => void;
  onChangeHoliday: (value: ReservationBusinessDayType) => void;
  label: string;
  helpText: string;
}

const ReservationBusinessTimeRange: FC<Props> = (props: Props) => {
  return (
    <>
      <Form style={ {marginBottom: "1rem"} }>
        <Form.Group inline={ true }>
          <TimeRangeSelector
            label={ props.label }
            from={ props.reservationBusinessTime.from }
            to={ props.reservationBusinessTime.to }
            onChangeFrom={ (value: Time) => props.onChangeFrom(value) }
            onChangeTo={ (value: Time) => props.onChangeTo(value) }
            helpText={ props.helpText }
          />
          <Checkbox
            label="定休日"
            checked={ props.reservationBusinessTime.dayType.value === ReservationBusinessDayType.REGULAR_HOLIDAY }
            onChange={ () => props.onChangeHoliday(props.reservationBusinessTime.dayType.value === ReservationBusinessDayType.REGULAR_HOLIDAY ? ReservationBusinessDayType.BUSINESS_DAY : ReservationBusinessDayType.REGULAR_HOLIDAY) }
          />
        </Form.Group>
      </Form>
    </>
  );
};

export default ReservationBusinessTimeRange;